import axios from '@/lib/axios'
import { buildAdminRequestConfig, type OrganizationId } from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type { MetaPixelIntegration, MetaPixelIntegrationInput } from './meta-pixel.types'

export interface MetaPixelOrganizationScope {
  organizationId: OrganizationId
}

/** Query functions read only the key. */
type MetaPixelQueryContext<TKey> = Pick<QueryFunctionContext<[TKey]>, 'queryKey'>

export function getMetaPixelIntegration({
  queryKey: [{ organizationId }],
}: MetaPixelQueryContext<MetaPixelOrganizationScope>) {
  return axios.get<MetaPixelIntegration>(
    '/meta-pixel/integration',
    buildAdminRequestConfig({ organizationId })
  )
}

export function updateMetaPixelIntegration({
  organizationId,
  pixel_id,
}: MetaPixelIntegrationInput & MetaPixelOrganizationScope) {
  return axios.put<MetaPixelIntegration>(
    '/meta-pixel/integration',
    { pixel_id },
    buildAdminRequestConfig({ organizationId })
  )
}

/** Disconnects the pixel and resolves to the disconnected integration. */
export function removeMetaPixelIntegration({ organizationId }: MetaPixelOrganizationScope) {
  return axios.delete<MetaPixelIntegration>(
    '/meta-pixel/integration',
    buildAdminRequestConfig({ organizationId })
  )
}
